import React from 'react';
import {
  IFragmentFragmentScreenDTO,
  IProteinFormulationInfoDTO,
  IProteinFormulationIngredientsDTO,
  IProteinFormulationStandardIngredientsDTO,
} from './Models';
import { IngredientStockDto } from 'components/Experiment/constants';

export interface WellInfoTemp {
  proteinFormulationIngredients: IProteinFormulationIngredientsDTO[];

  proteinFormulationStandardIngredients: IProteinFormulationStandardIngredientsDTO[];

  additives: Additives[];

  wellInfo: WellInfo;

  proteinInfo: IProteinFormulationInfoDTO;

  ingredients: LayerIngredient[];

  seedInfo: SeedInfo;
  dropFragmentInfo: IFragmentFragmentScreenDTO[];
}

export class WellInfo {
  dropProteinVolume: number;
  dropWellVolume: number;
}

export class SeedInfo {
  seedName: string;
}

export type LayerRowProps = {
  icon: any;
  title: string;
  children?: any;
  onUpdate?: (e) => React.ReactNode;
  onDelete?: (e) => React.ReactNode;
};

export class LayerIngredient {
  ingredientColor: string;

  concentration: number;

  concentrationUnit: string;

  ingredientName: string;

  ingredientTypeName: string;

  ingredientStock?: IngredientStockDto;

  highPhIngStock?: IngredientStockDto;

  highPHVolume?: number;

  ingredientVolume?: number;

  dropNumber?: number;
  pH?: number;
}

export class Additives {
  ingredientColor: string;

  concentration: number;

  concentrationUnit: string;

  ingredientName: string;

  ingredientTypeName: string;

  stockConcentration: number;

  volume: number;
}
